"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = LoginButton;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactSpinnerChildren = _interopRequireDefault(require("react-spinner-children"));

var _Login = _interopRequireDefault(require("./Login"));

function LoginButton(props) {
  var children = props.children,
      className = props.className,
      spinner = props.spinner,
      spinnerConfig = props.spinnerConfig,
      rest = (0, _objectWithoutPropertiesLoose2["default"])(props, ["children", "className", "spinner", "spinnerConfig"]);
  return _react["default"].createElement(_Login["default"], rest, function (_ref) {
    var loading = _ref.loading,
        handleClick = _ref.handleClick;
    return _react["default"].createElement("button", {
      type: "button",
      className: className,
      onClick: handleClick,
      disabled: loading
    }, children, spinner && loading && _react["default"].createElement(_reactSpinnerChildren["default"], {
      config: spinnerConfig
    }));
  });
}

LoginButton.defaultProps = (0, _extends2["default"])({}, _Login["default"].defaultProps, {
  className: undefined,
  spinnerConfig: {},
  spinner: true
});